exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".execution-marker.stage {\n  margin-top: 0;\n  display: inline-block;\n  height: 20px;\n  opacity: 0.65;\n  -webkit-transition: 0.2s all;\n  transition: 0.2s all;\n  text-align: center;\n  padding: 0;\n  color: var(--color-black);\n  font-size: 90%;\n  border: 1px solid transparent;\n  border-left-color: var(--color-white);\n  vertical-align: middle;\n}\n.execution-marker.stage:hover,\n.execution-marker.stage.active {\n  opacity: 1;\n}\n.execution-marker.stage.after-active {\n  border-left-color: transparent;\n}\n.execution-marker.stage.active {\n  border-color: var(--color-mineshaft);\n}\n.execution-marker.stage.active:first-child {\n  border-left-width: 1px;\n}\n.execution-marker.stage.active:last-child {\n  border-right-width: 1px;\n}\n.execution-marker.stage.glowing {\n  -webkit-animation: animate-glow 2.5s steps(30) infinite;\n  -moz-animation: animate-glow 2.5s steps(30) infinite;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/pipeline/executions/execution/executionMarker.less
// module id = 2611
// module chunks = 0